import styled from "styled-components";

export interface GroupedFiltersProps {
  children: React.ReactNode[];
  title: string;
}
const StyledGroupedFilters = styled.fieldset`
  margin-top: 12px;
  border: 1px solid rgb(178, 182, 191);
  margin-inline-start: 2px;
  margin-inline-end: 2px;
  padding-block-start: 0.35em;
  padding-inline-start: 0.75em;
  padding-inline-end: 0.75em;
  padding-block-end: 0.625em;
  min-inline-size: min-content;
  > * {
    margin-bottom: 8px;
  }
`;
const StyledGroupedFiltersTitle = styled.legend`
  width: auto;
  margin: 0;
  margin-left: auto;
  padding-inline-start: 2px;
  padding-inline-end: 2px;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
  font-size: 0.95rem;
`;

export const GroupedFilters = ({ children, title }: GroupedFiltersProps) => {
  return (
    <StyledGroupedFilters>
      <StyledGroupedFiltersTitle>{title}</StyledGroupedFiltersTitle>
      {children}
    </StyledGroupedFilters>
  );
};
